import { render, staticRenderFns } from "./OrderDetailTabDocuments.vue?vue&type=template&id=e5888c26"
import script from "./OrderDetailTabDocuments.vue?vue&type=script&lang=js"
export * from "./OrderDetailTabDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports